<template>
	<el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
		unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
		active-text-color="#ffd04b" >
		<div class="logobox">
			<img class="logoimg" src="../assets/img/fa.png" alt="404">
		</div>
		<el-submenu v-for="menu in allmenu" :key="menu.LItemID" :index="menu.LName" @click="clickMenu2(menu)">
			<!--@click="clickMenu(menu.menuname)
			-->
			<template slot="title">
				<i class="iconfont" :class="menu.icon"></i>
				<span @click="clickMenu2(menu)">{{menu.LName}}</span>
			</template>
			<el-menu-item-group>
				<el-menu-item v-for="chmenu in menu.menus" :index="chmenu.FURL" :key="chmenu.LItemID"
					@click="clickMenu(chmenu.LName,chmenu.FURL,chmenu)" 
					 :route="{path:chmenu.FURL,query:{LItemID:JSON.stringify(chmenu),t:ta}}"
					>
					<i class="iconfont" :class="chmenu.icon"></i>
					<span>{{chmenu.LName}}</span>
				</el-menu-item>
			</el-menu-item-group>
		</el-submenu>
	</el-menu>
</template>
<script>
	import {
		Lmenu,
		menu
	} from '../api/userMG'
	export default {
		name: 'leftnav',
		data() {
			return {
				collapsed: false,
				allmenu: [],
				ta:Date.now(),
				v_str_AccountID:'165'
				//'160'
			}
		},
		// 创建完毕状态(里面是操作)
		created() {
			// 获取图形验证码
			let menu1 = { //业务
				//success: true,
				v_str_AccountID: this.v_str_AccountID,
				UserName: 'admin',
        ShowType: 1,
        LType:""
        
				//msg: 'success'
			}
			let menu2 = { //基础
				// success: true,
				v_str_AccountID: this.v_str_AccountID,
				UserName: 'admin',
        ShowType: 0,
        LType:""
				// msg: 'success'
			}
      let men = []
      console.log(menu1)
			Lmenu(menu1).then(res => {
				console.log(res)
				men = res.Data
			}).then((res => {
				Lmenu(menu2).then(res2 => {
					for (let i = 0; i < res2.Data.length; i++) {
						let arr2 = res2.Data[i]
						console.log(arr2)
						men.push(arr2)
					}
					this.allmenu = men
					console.log(men)
				})
			})).catch(err => {
				this.$message.error('菜单加载失败，请稍后再试！')
			})
			// 监听
			this.$root.Bus.$on('toggle', value => {
				console.log(value)
				this.collapsed = !value
			})
		},

		methods: {
			//跳转路由 根据名称跳转
			clickMenu(item,i,val) {
			 val["name"]=val.LName
			 console.log(item,i,val)
			  //调用vuex的selectMenu方法存储数据
			//  this.$store.commit('selectMenu', item)
				 this.$store.commit("pushtags",val)
			  // //跳转路由
			  // this.$router.push({
			  //   name: item.name
			  // })
			},
			clickMenu2(item) {
				let cos = item.LName
			//	console.log(item)
				//   //调用vuex的selectMenu方法存储数据
 //this.$store.commit("pushtags",item)
				//   //跳转路由
				this.$router.push({
					path: '/goods/menu',
					query: {
						LName: JSON.stringify(item.LItemID),
						t: Date.now()
					},
					meta: {
					    requireAuth: true,
						keepAlive: true
					}
					
				})
			},

		}
	}
</script>
<style>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 100%;
		min-height: 400px;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		border: none;
		text-align: left;
	}

	.el-menu-item-group__title {
		padding: 0px;
	}

	.el-menu-bg {
		background-color: #1f2d3d !important;
	}

	.el-menu {
		border: none;
	}

	.logobox {
		height: 40px;
		line-height: 40px;
		color: #9d9d9d;
		font-size: 20px;
		text-align: center;
		padding: 20px 0px;
	}

	.logoimg {
		height: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue